// latest: zhangmyh 2017-10-12 1:57 PM
import 'collection/approveLog'
import Collection from 'common/vo/collection'
/* global $ u */
// let _config
async function init (refer) {
  // 每次都重新加载
  let collection = Collection.create('approveLogList')
  // await collection.load({ supplyId: refer.options.supid })
  await collection.load({ supplyId: refer.options.supid, pageSize: 50 })
  $('.u-msg-footer').find('.u-msg-cancel').hide()
  let vm = {
    config: {
      id: 'approvelog_grid',
      data: collection,
      type: 'grid',
      multiSelect: false,
      editable: true,
      pagination: false,
      fields: [{
        field: 'bizType',
        dataType: 'String',
        title: '类型',
        editable: false,
        width: '15 %'
      }, {
        field: 'userName',
        dataType: 'String',
        title: '审批人',
        editable: false,
        width: '15 %'
      }, {
        field: 'occurTime',
        dataType: 'Date',
        title: '日期',
        editable: false,
        width: '20%'
      }, {
        field: 'advice',
        dataType: 'String',
        title: '审批结果',
        editable: true,
        width: '50%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#approveLog')[0])
}

let template = require('./index.html')
export default function (config) {
  // _config = Object.assign({
  //   type: false
  // }, config)

  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/approveLog/index.js